import { render, staticRenderFns } from "./ViewResultsModal.vue?vue&type=template&id=33d08632&"
import script from "./ViewResultsModal.vue?vue&type=script&lang=ts&"
export * from "./ViewResultsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports